import Vue from 'vue';
import VueRouter from 'vue-router';

import SiteCreationForm from '@/views/SiteCreationForm/SiteCreationForm';
import {
  StepZero,
  StepOfficeName,
  StepCoworkerNumber,
  StepAlreadyClient,
  StepSolencyHearing,
  StepAddress,
  StepContact,
  StepSpecialities,
  StepDomains,
  StepDescription,
  StepSocialNetworks,
  StepCoWorkers,
  // StepLegals,
  StepTemplateChoice,
  StepCustomization,
  StepLoading,
  StepFinale,
} from '@/views/SiteCreationForm/Steps';

import {
  Dashboard,
  Home,
  SiteSettings,
  Stats,
  Mailbox,
  Appointments,
  MyAccount,
  Posts,
  Post,
} from '@/views/Dashboard';

import {
  Connection,
  ForgotPassword,
  ResetPassword,
  Welcome,
  Preview,
} from '@/views/Authentication';

import DeferralRequestAction from '@/views/EmailClientActions/AppointmentDeferralRequest';

import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    name: 'Landing',
  },
  {
    path: '/connexion',
    name: 'Connection',
    component: Connection,
  },
  {
    path: '/mot-de-passe-perdu',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/changement-mot-de-passe',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/verification-email',
    name: 'EmailCheckIn',
    component: () => import('@/views/Authentication/EmailCheckIn'),
  },
  {
    path: '/verifier-email',
    name: 'VerifyEmail',
    component: () => import('@/views/Authentication/VerifyEmail'),
  },
  {
    path: '/bienvenue',
    name: 'Welcome',
    component: Welcome,
  },
  {
    path: '/preview',
    name: 'preview',
    component: Preview,
  },
  {
    path: '/creation-site/',
    name: 'SiteCreation',
    component: SiteCreationForm,
    children: [
      {
        path: '0',
        name: 'StepZero',
        component: StepZero,
      },
      {
        path: '1',
        name: 'StepOfficeName',
        component: StepOfficeName,
      },
      {
        path: '2',
        name: 'StepAddress',
        component: StepAddress,
      },
      {
        path: '3',
        name: 'StepContact',
        component: StepContact,
      },
      {
        path: '4',
        name: 'StepSpecialities',
        component: StepSpecialities,
      },
      {
        path: '5',
        name: 'StepDomains',
        component: StepDomains,
      },
      {
        path: '6',
        name: 'StepDescription',
        component: StepDescription,
      },
      {
        path: '7',
        name: 'StepSocialNetworks',
        component: StepSocialNetworks,
      },
      {
        path: '8',
        name: 'StepCoWorkers',
        component: StepCoWorkers,
      },
      {
        path: '9',
        name: 'StepTemplateChoice',
        component: StepTemplateChoice,
      },
      {
        path: '10',
        name: 'StepCustomization',
        component: StepCustomization,
      },
      {
        path: '11',
        name: 'StepDomainName',
        component: () => import('@/views/SiteCreationForm/Steps/StepDomainName'),
      },
      {
        path: '12',
        name: 'StepSolencyHearing',
        component: StepSolencyHearing,
      },
      {
        path: '13',
        name: 'StepCoworkerNumber',
        component: StepCoworkerNumber,
      },
      {
        path: '14',
        name: 'StepAlreadyClient',
        component: StepAlreadyClient,
      },
      {
        path: '15',
        name: 'StepLoading',
        component: StepLoading,
      },
      {
        path: '16',
        name: 'StepFinale',
        component: StepFinale,
      },
    ],
  },
  {
    path: '/dashboard/',
    component: Dashboard,
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: Home,
      },
      {
        path: 'site-settings',
        name: 'SiteSettings',
        component: SiteSettings,
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats,
      },
      {
        path: 'messagerie',
        name: 'Mailbox',
        component: Mailbox,
      },
      {
        path: 'appointments',
        name: 'Appointments',
        component: Appointments,
      },
      {
        path: 'mon_compte',
        name: 'MyAccount',
        component: MyAccount,
      },
      {
        path: 'articles',
        name: 'Posts',
        component: Posts,
      },
      {
        path: 'article',
        name: 'Post',
        component: Post,
      },
    ],
  },
  {
    path: '/appointments/deferral-request',
    name: 'DeferralRequest',
    component: DeferralRequestAction,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const anonymousRoutes = [
    'Connection',
    'Register',
    'ForgotPassword',
    'ResetPassword',
    'DeferralRequest',
  ];

  if (!anonymousRoutes.includes(to.name) && !store.getters['auth/isTokenValid']) {
    return next({ name: 'Connection', query: { redirectTo: to.fullPath } });
  }

  const emailVerificationRoutes = ['VerifyEmail', 'EmailCheckIn'];

  if (
    !store.getters['auth/isActive'] &&
    !emailVerificationRoutes.includes(to.name) &&
    !anonymousRoutes.includes(to.name)
  ) {
    return next({ name: 'VerifyEmail' });
  }

  if (!store.getters['user/isLogged'] || store.getters['auth/getToken'] != '') {
    await store.dispatch('user/login', store.getters['auth/getToken']);
  }

  if (to.name === 'Landing') {
    if (to.query.token) {
      await store.dispatch('site/updateToken', to.query.token);
    }

    return next({ name: 'DashboardHome' });
  }

  next();
});

export default router;
